module.exports = __webpack_public_path__ + "static/media/ensa.d0ca60d4.png";